import axios from 'axios'
import {
  FormValuesResource,
  ModelRoles_x_Aplicativo_x_OrgVenta,
  ModelService_Categoria,
  ModelService_Categorias,
  ModelService_ClienteEmpresarial,
  ModelService_ClienteEmpresariales,
  ModelService_ClientePersona,
  ModelService_ClientePersonas,
  ModelService_Consentimiento,
  ModelService_Consentimientos,
  ModelService_ConsentPersona,
  ModelService_ConsentPersonas,
  ModelService_Constante,
  ModelService_Constantes,
  ModelService_Empleado,
  ModelService_Empleados,
  ModelService_EspecifTecnica,
  ModelService_EspecifTecnicas,
  ModelService_Filter,
  ModelService_Filter2,
  ModelService_Filter_Sort_Car,
  ModelService_GrpConsentimiento,
  ModelService_GrpConsentimientos,
  ModelService_Locales,
  ModelService_OrgVentasxLocal,
  ModelService_OrgVentasxLocales,
  ModelService_PersonaContacto,
  ModelService_PersonaContactos,
  ModelService_Reclamacion,
  ModelService_Reclamaciones,
  ModelService_RecursoOrgVenta,
  ModelService_RecursoOrgVentas,
  ModelService_Survey,
  ModelService_Surveys,
  ModelService_UnidadMedida,
  ModelService_UnidadMedidas,
  ModelServiceActividades,
  ModelServiceAplicativo_x_OrgVentas,
  ModelServiceAplicativoOvUsuario,
  ModelServiceDispositivos,
  ModelServiceDocumento,
  ModelServiceDocumentos,
  ModelServiceDomicilio,
  ModelServiceDomicilios,
  ModelServiceInteraccion,
  ModelServiceInteracciones,
  ModelServiceMetodosFA,
  ModelServiceOrgSaas,
  ModelServicePaises,
  ModelServiceRol_Usuario,
  ModelServiceRol_Usuarios,
  ModelServiceRoles,
  ModelServiceRoles_x_Aplicativo_x_OrgVenta,
  ModelServiceRoles_x_Aplicativo_x_OrgVentas,
  ModelServiceTipoDocumentos,
  ModelServiceTipoUsuarios,
  ModelServiceUsuario,
  ModelServiceUsuarios,
  ModelServiceVerificacion,
  ModelServiceVerificaciones,
} from './_models'
import {
  CarsDetailModel,
  CarsModel1,
  ModelService_Authenticator,
  ModelService_CanalDist,
  ModelService_CanalDists,
  ModelService_Car,
  ModelService_CarDetail,
  ModelService_Cars,
  ModelService_CarsDetails,
  ModelService_Centro,
  ModelService_Centros,
  ModelService_Conductor,
  ModelService_Conductores,
  ModelService_Contacteno,
  ModelService_Contactenos,
  ModelService_EsquemaEstatu,
  ModelService_EsquemaEstatus,
  ModelService_Estatu,
  ModelService_Estatus,
  ModelService_FAP,
  ModelService_FAPS,
  ModelService_FAQ,
  ModelService_FAQS,
  ModelService_GrpVendedor,
  ModelService_GrpVendedores,
  ModelService_Localizacion,
  ModelService_OfVenta,
  ModelService_OfVentas,
  ModelService_OrgVenta,
  ModelService_OrgVentas,
  ModelService_Remove_Image,
  ModelService_Reserva,
  ModelService_Reservas,
  ModelService_Sector,
  ModelService_Sectors,
  ModelService_Sociedad,
  ModelService_Sociedades,
  ModelService_Token,
  ModelService_VerifyToken,
} from './_models'
import { getAuth, useAuth } from '../../auth'

const RENTACAR_API_URL = process.env.REACT_APP_API_URL_RENTACAR_SERVER

export const REACT_IMAGE_KIT_URL_ENDPOINT = process.env.REACT_APP_API_URL_IMAGE_KIT_URL_ENDPOINT
export const REACT_IMAGE_KIT_PUBLIC_KEY = process.env.REACT_APP_API_URL_IMAGE_KIT_PUBLIC_KEY

export const CENTROS_URL = `${RENTACAR_API_URL}/locales`
export const ORG_VENTAS_URL = `${RENTACAR_API_URL}/org_ventas`
export const CAT_ORG_VENTAS_URL_OB = `${RENTACAR_API_URL}/cat_orgventas`
export const ESQUEMA_ESTATUS_URL = `${RENTACAR_API_URL}/esquema_estatus`
export const ESTATUS_URL = `${RENTACAR_API_URL}/estatus`
export const CANAL_DIST_URL = `${RENTACAR_API_URL}/canal_distribucion`
export const SECTOR_URL = `${RENTACAR_API_URL}/sector`
export const CARS_URL = `${RENTACAR_API_URL}/resource`
export const CARS_DETAIL_URL = `${RENTACAR_API_URL}/resource_details`
export const RESERVA_URL = `${RENTACAR_API_URL}/reserva`
export const AUTHENTICATOR_IMAGE_URL = `${RENTACAR_API_URL}/image_kit`
export const SOCIEDAD_URL = `${RENTACAR_API_URL}/sociedad`
export const OF_VENTAS_URL = `${RENTACAR_API_URL}/oficinas_de_ventas`
export const GRP_VENDEDOR_URL = `${RENTACAR_API_URL}/grupo_de_vendedor`
export const FAQ_URL = `${RENTACAR_API_URL}/FAQ`
export const FAP_URL = `${RENTACAR_API_URL}/FAP`
export const CONDUCTOR_URL = `${RENTACAR_API_URL}/conductor`
export const USUARIO_URL = `${RENTACAR_API_URL}/usuarios`
export const CONTACTENOS_URL = `${RENTACAR_API_URL}/contactenos`
export const RECLAMACIONES_URL = `${RENTACAR_API_URL}/libro_reclamaciones`
export const LOCALES_URL= `${RENTACAR_API_URL}/locales`

export const SURVEY_URL = `${RENTACAR_API_URL}/survey`

export const CLIENTES_PERSONA_URL = `${RENTACAR_API_URL}/cliente_persona`
export const CLIENTES_EMPRESARIAL_URL = `${RENTACAR_API_URL}/cliente_empresarial`
export const PERSONA_CONTACTO_URL = `${RENTACAR_API_URL}/persona_contacto`
export const CONTACTO_CONSENTIMIENTO_URL = `${RENTACAR_API_URL}/consent_perscont`
export const EMPLEADO_URL = `${RENTACAR_API_URL}/empleados`
export const CONSTANTES_URL = `${RENTACAR_API_URL}/constante`
export const ESPECIFICACIONES_TECNICAS_URL = `${RENTACAR_API_URL}/especificaciones_tecnicas`

export const GRP_CONSENTIMIENTO_URL = `${RENTACAR_API_URL}/grupo_consentimiento`
export const CONSENTIMIENTO_URL = `${RENTACAR_API_URL}/consentimientos`

export const LOCALIZACION_URL = `${RENTACAR_API_URL}/localizacion`
export const TOKEN_URL = `${RENTACAR_API_URL}/auth`

export const USUARIO_ONBOARDING_URL = `${RENTACAR_API_URL}/usuarios`
export const ORGSAAS_ONBOARDING_URL = `${RENTACAR_API_URL}/org_saas`
export const PAIS_ONBOARDING_URL = `${RENTACAR_API_URL}/pais`
export const ROL_ONBOARDING_URL = `${RENTACAR_API_URL}/cat_rol`
export const TIPO_USUARIO_ONBOARDING_URL = `${RENTACAR_API_URL}/cat_tipousuario`

export const DOCUMENTO_URL = `${RENTACAR_API_URL}/documento`
export const TIPO_DOCUMENTO_URL = `${RENTACAR_API_URL}/cat_tipodocumento`

export const VERIFICACION_URL = `${RENTACAR_API_URL}/verificacionidentidad`
export const DOMICILIO_URL = `${RENTACAR_API_URL}/domicilio`

export const INTERACCION_URL = `${RENTACAR_API_URL}/interaccion`
export const METODOFA_URL = `${RENTACAR_API_URL}/metodo2fa`
export const ACTIVIDAD_URL = `${RENTACAR_API_URL}/actividadporetapa`
export const DISPOSITIVO_URL = `${RENTACAR_API_URL}/dispositivo`

export const ROLES_X_APLICATIVO_X_OV_URL = `${RENTACAR_API_URL}/roles_x_aplicat_x_ov`
export const ROL_X_USUARIO_URL = `${RENTACAR_API_URL}/rol_x_usuario`
export const APLICATIVO_X_OV_URL = `${RENTACAR_API_URL}/aplicativo_x_ov`

export const ORG_VENTAS_X_LOCALES_URL = `${RENTACAR_API_URL}/orgventas_x_locales`
export const APLICATIVO_OV_USUARIO_URL = `${RENTACAR_API_URL}/aplicativo_x_ov_x_usuario`
export const CATEGORIA_URL = `${RENTACAR_API_URL}/categoria`
export const UNIDADMEDIDA_URL = `${RENTACAR_API_URL}/unidad_medida`
export const RECURSO_ORGVENTAS_URL = `${RENTACAR_API_URL}/resource_x_ov`

//CENTROS
export function createCentros(Descripcion: string, IdLocalizacion: number, Activo: boolean) {
  return axios.post<ModelService_Centro>(`${CENTROS_URL}/create`, {
    Descripcion,
    IdLocalizacion,
    Activo,
  })
}

export function findAllCentros(value: ModelService_Filter) {
  return axios.post<ModelService_Centros>(`${CENTROS_URL}/find_all`, value)
}

export function findOneCentros(id: number) {
  return axios.get<ModelService_Centro>(`${CENTROS_URL}/find_one/${id}`)
}

export function updateCentros(
  idCentro: number,
  Descripcion: string,
  IdLocalizacion: number,
  Activo: boolean
) {
  return axios.patch<ModelService_Centro>(`${CENTROS_URL}/update/${idCentro}`, {
    Descripcion,
    IdLocalizacion,
    Activo,
  })
}

export function removeCentros(id: number) {
  return axios.post<ModelService_Centro>(`${CENTROS_URL}/remove/${id}`)
}

//ORG VENTAS
export function createOrgVenta(
  IdOrgV: string,
  Descripcion: string,
  IdSociedad: string | null,
  // DominioWeb: string | null,
  IdOrgSaas: number,
  IdOrgVExt: string | null,
  IdIndustria: number,
  Activo: boolean
) {
  return axios.post<ModelService_OrgVenta>(`${ORG_VENTAS_URL}/create_sync`, {
    IdOrgV,
    Descripcion,
    IdSociedad,
    // DominioWeb,
    IdOrgSaas,
    IdOrgVExt,
    IdIndustria,
    Activo,
  })
}

export function findAllOrgVentas(value: ModelService_Filter, idOrgVentas: string, idRol: string) {
  const payload = {
    ...value,
    IdOrgV: idOrgVentas,
    IdRol: idRol,
  }

  return axios.post<ModelService_OrgVentas>(`${ORG_VENTAS_URL}/find_all2`, payload)
}

export function findAllCat_OrgVentas_Ob(value: ModelService_Filter, token: string) {
  const payload = {
    ...value,
    token: token,
  }
  return axios.post<ModelService_OrgVentas>(`${CAT_ORG_VENTAS_URL_OB}/find_all`, payload)
}

export function findAllByOrgVentasOrgSaas(IdOrgSaas: number) {
  return axios.post<ModelService_OrgVentas>(`${ORG_VENTAS_URL}/find_all_by_orgsaas`, {
    IdOrgSaas,
  })
}

export function findAllOrgVentasBySociedad(id: string) {
  return axios.get<ModelService_OrgVentas>(`${ORG_VENTAS_URL}/find_all_by_sociedad/${id}`)
}

export function findOneOrgVenta(id: string) {
  return axios.get<ModelService_OrgVenta>(`${ORG_VENTAS_URL}/find_one/${id}`)
}

export function updateOrgVenta(
  IdOrgV: string,
  Descripcion: string,
  IdSociedad: string | null,
  // DominioWeb: string | null,
  IdOrgSaas: number,
  IdOrgVExt: string | null,
  IdIndustria: number,
  Activo: boolean
) {
  return axios.patch<ModelService_OrgVenta>(`${ORG_VENTAS_URL}/update_sync/${IdOrgV}`, {
    Descripcion,
    IdSociedad,
    // DominioWeb,
    IdOrgSaas,
    IdOrgVExt,
    IdIndustria,
    Activo,
  })
}

export function removeOrgVenta(id: string) {
  return axios.post<ModelService_OrgVenta>(`${ORG_VENTAS_URL}/remove_sync/${id}`)
}

//ESQUEMA ESTATUS
export function createEsquemaEstatu(
  IdEsquemaEstatus: string,
  Descripcion: string,
  Activo: boolean
) {
  return axios.post<ModelService_EsquemaEstatu>(`${ESQUEMA_ESTATUS_URL}/create`, {
    IdEsquemaEstatus,
    Descripcion,
    Activo,
  })
}

export function findAllEsquemaEstatus(value: ModelService_Filter) {
  return axios.post<ModelService_EsquemaEstatus>(`${ESQUEMA_ESTATUS_URL}/find_all`, value)
}

export function findOneEsquemaEstatu(id: string) {
  return axios.get<ModelService_EsquemaEstatu>(`${ESQUEMA_ESTATUS_URL}/find_one/${id}`)
}

export function updateEsquemaEstatu(
  IdEsquemaEstatus: string,
  Descripcion: string,
  Activo: boolean
) {
  return axios.patch<ModelService_EsquemaEstatu>(
    `${ESQUEMA_ESTATUS_URL}/update/${IdEsquemaEstatus}`,
    {
      IdEsquemaEstatus,
      Descripcion,
      Activo,
    }
  )
}

export function removeEsquemaEstatu(id: string) {
  return axios.post<ModelService_EsquemaEstatu>(`${ESQUEMA_ESTATUS_URL}/remove/${id}`)
}

// ESTATUS
export function createEstatus(Descripcion: string, IdEsquemaEstatus: string, Activo: boolean) {
  return axios.post<ModelService_Estatu>(`${ESTATUS_URL}/create`, {
    Descripcion,
    IdEsquemaEstatus,
    Activo,
  })
}

export function findAllEstatus(value: ModelService_Filter) {
  return axios.post<ModelService_Estatus>(`${ESTATUS_URL}/find_all`, value)
}

export function findOneEstatus(id: string) {
  return axios.get<ModelService_Estatu>(`${ESTATUS_URL}/find_one/${id}`)
}

export function updateEstatus(
  id: number,
  Descripcion: string,
  IdEsquemaEstatus: string,
  Activo: boolean
) {
  return axios.patch<ModelService_Estatu>(`${ESTATUS_URL}/update/${id}`, {
    Descripcion,
    IdEsquemaEstatus,
    Activo,
  })
}

export function removeEstatus(id: number) {
  return axios.post<ModelService_Estatu>(`${ESTATUS_URL}/remove/${id}`)
}

// CANAL DISTRIBUCION
export function createCanalDist(
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.post<ModelService_CanalDist>(`${CANAL_DIST_URL}/create`, {
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function findAllCanalDist(value: ModelService_Filter) {
  return axios.post<ModelService_CanalDists>(`${CANAL_DIST_URL}/find_all`, value)
}

export function findOneCanalDist(id: string) {
  return axios.get<ModelService_CanalDist>(`${CANAL_DIST_URL}/find_one/${id}`)
}

export function updateCanalDist(
  id: string,
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.patch<ModelService_CanalDist>(`${CANAL_DIST_URL}/update/${id}`, {
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function removeCanalDist(id: string) {
  return axios.post<ModelService_CanalDist>(`${CANAL_DIST_URL}/remove/${id}`)
}

// SECTOR
export function createSector(
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.post<ModelService_Sector>(`${SECTOR_URL}/create`, {
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function findAllSector(value: ModelService_Filter) {
  return axios.post<ModelService_Sectors>(`${SECTOR_URL}/find_all`, value)
}

export function findOneSector(id: string) {
  return axios.get<ModelService_Sector>(`${SECTOR_URL}/find_one/${id}`)
}

export function updateSector(
  id: string,
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.patch<ModelService_Sector>(`${SECTOR_URL}/update/${id}`, {
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function removeSector(id: string) {
  return axios.post<ModelService_Sector>(`${SECTOR_URL}/remove/${id}`)
}

// CARS
export function createCar(data: CarsModel1) {
  return axios.post<ModelService_Car>(`${CARS_URL}/create`, data)
}

export function createResource(data: FormValuesResource) {
  return axios.post<ModelService_Car>(`${CARS_URL}/create`, data)
}

export function findAllCars(value: ModelService_Filter) {
  return axios.post<ModelService_Cars>(`${CARS_URL}/find_all`, value)
}

export function findAllCars2(value: ModelService_Filter) {
  return axios.post<ModelService_Cars>(`${CARS_URL}/find_all2`, value)
}

export function findOneCar(id: number) {
  return axios.get<ModelService_Car>(`${CARS_URL}/find_one/${id}`)
}

export function updateCar(
  id: number,
  PrecioValor: number | null,
  PrecioTitulo: string | null,
  Telefono: string | null,
  BotonReservarTexto: string | null,
  BotonReservarLink: string | null,

  NombreImagen: string | null,
  FileBase64: string | null,

  Activo: boolean,
  IdOrgV: string,
  CriterioOrden2: number | null,
  IdCategoria: number | null,

  DescripcionGeneral: string | null,
  Nombre: string | null,
  IdUM: string | null,
  AplicarImpuesto: boolean
) {
  return axios.patch<ModelService_Car>(`${CARS_URL}/update/${id}`, {
    PrecioValor,
    PrecioTitulo,
    Telefono,
    BotonReservarTexto,
    BotonReservarLink,

    NombreImagen,
    FileBase64,

    Activo,
    IdOrgV,
    CriterioOrden2,
    IdCategoria,

    DescripcionGeneral,
    Nombre,
    IdUM,
    AplicarImpuesto,
  })
}

export function removeCar(id: number) {
  return axios.post<ModelService_Car>(`${CARS_URL}/remove/${id}`)
}

// CARS DETAILS
export function createCarDetail(data: CarsDetailModel[]) {
  return axios.post<ModelService_CarsDetails>(`${CARS_DETAIL_URL}/create`, data)
}

export function findAllCarDetails(value: ModelService_Filter) {
  return axios.post<ModelService_CarsDetails>(`${CARS_DETAIL_URL}/find_all`, value)
}

export function findOneCarDetail(id: string) {
  return axios.get<ModelService_CarDetail>(`${CARS_DETAIL_URL}/find_one/${id}`)
}

export function updateCarDetail(
  id: number,
  IdResource: number,
  ItemTitle: number,
  ItemDetail: string,

  NombreItemIcon: string | null,
  FileBase64: string | null,

  Activo: boolean,
  ViewFront: boolean,
  MostrarEnFiltro: boolean
) {
  return axios.patch<ModelService_CarDetail>(`${CARS_DETAIL_URL}/update/${id}`, {
    IdResource,
    ItemTitle,
    ItemDetail,

    NombreItemIcon,
    FileBase64,

    Activo,
    ViewFront,
    MostrarEnFiltro,
  })
}

export function removeCarDetail(id: number) {
  return axios.post<ModelService_CarDetail>(`${CARS_DETAIL_URL}/remove/${id}`)
}

// RESERVAS
export function createReserva(
  IdResource: number,
  IdEntrega: number,
  IdDevolucion: number,
  FechaEntrega: string,
  FechaDevolucion: string,
  // IdConductor: number,
  IdEstatus: number,
  IdGrupoVendedor: string | null,
  IdClienteEmpresarial: number | null,
  IdClientePersona: number | null,
  Activo: boolean
) {
  return axios.post<ModelService_Reserva>(`${RESERVA_URL}/createBO`, {
    IdResource,
    IdEntrega,
    IdDevolucion,
    FechaEntrega,
    FechaDevolucion,
    // IdConductor,
    IdEstatus,
    IdGrupoVendedor,
    IdClienteEmpresarial,
    IdClientePersona,
    Activo,
  })
}

export function findAllReservas(value: ModelService_Filter) {
  return axios.post<ModelService_Reservas>(`${RESERVA_URL}/find_all`, value)
}

export function findAllReservasbyOrgVentas(value: ModelService_Filter, orgventas: string) {
  const payload = {
    ...value,
    IdOrgV: orgventas,
  }

  return axios.post<ModelService_Reservas>(`${RESERVA_URL}/find_all_by_orgventas`, payload)
}

export function findOneReserva(id: string) {
  return axios.get<ModelService_Reserva>(`${RESERVA_URL}/find_one/${id}`)
}

export function updateReserva(
  id: number,
  IdResource: number,
  IdEntrega: number,
  IdDevolucion: number,
  FechaEntrega: string,
  FechaDevolucion: string,
  // IdConductor: number,
  IdEstatus: number,
  IdGrupoVendedor: string | null,
  IdClienteEmpresarial: number | null,
  IdClientePersona: number | null,
  Activo: boolean
) {
  return axios.patch<ModelService_Reserva>(`${RESERVA_URL}/update/${id}`, {
    IdResource,
    IdEntrega,
    IdDevolucion,
    FechaEntrega,
    FechaDevolucion,
    // IdConductor,
    IdEstatus,
    IdGrupoVendedor,
    IdClienteEmpresarial,
    IdClientePersona,
    Activo,
  })
}

export function removeReserva(id: number) {
  return axios.post<ModelService_Reserva>(`${RESERVA_URL}/remove/${id}`)
}

//IMAGE KIT

export function authenticator() {
  return axios.get<ModelService_Authenticator>(`${AUTHENTICATOR_IMAGE_URL}/auth`)
}

export function removeImage(id: string) {
  return axios.post<ModelService_Remove_Image>(`${AUTHENTICATOR_IMAGE_URL}/remove/${id}`)
}

//SOCIEDAD
export function createSociedad(IdSociedad: string, Descripcion: string, Activo: boolean) {
  return axios.post<ModelService_Sociedad>(`${SOCIEDAD_URL}/create`, {
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function findAllSociedades(value: ModelService_Filter) {
  return axios.post<ModelService_Sociedades>(`${SOCIEDAD_URL}/find_all`, value)
}

export function findOneSociedad(id: string) {
  return axios.get<ModelService_Sociedad>(`${SOCIEDAD_URL}/find_one/${id}`)
}

export function updateSociedad(IdSociedad: string, Descripcion: string, Activo: boolean) {
  return axios.patch<ModelService_Sociedad>(`${SOCIEDAD_URL}/update/${IdSociedad}`, {
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function removeSociedad(id: string) {
  return axios.post<ModelService_Sociedad>(`${SOCIEDAD_URL}/remove/${id}`)
}

// OFICINAS DE VENTAS
export function createOfVentas(
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.post<ModelService_OfVenta>(`${OF_VENTAS_URL}/create`, {
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function findAllOfVentas(value: ModelService_Filter) {
  return axios.post<ModelService_OfVentas>(`${OF_VENTAS_URL}/find_all`, value)
}

export function findAllOfVentasByOrgVentas(id: string) {
  return axios.get<ModelService_OfVentas>(`${OF_VENTAS_URL}/find_all_by_orgventas/${id}`)
}

export function findOneOfVenta(id: string) {
  return axios.get<ModelService_OfVenta>(`${OF_VENTAS_URL}/find_one/${id}`)
}

export function updateOfVenta(
  id: string,
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.patch<ModelService_OfVenta>(`${OF_VENTAS_URL}/update/${id}`, {
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function removeOfVenta(id: string) {
  return axios.post<ModelService_OfVenta>(`${OF_VENTAS_URL}/remove/${id}`)
}

// GRUPO VENDEDOR
export function createGrpVendedor(
  IdOfV: string,
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.post<ModelService_GrpVendedor>(`${GRP_VENDEDOR_URL}/create`, {
    IdOfV,
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function findAllGrpVendedor(value: ModelService_Filter) {
  return axios.post<ModelService_GrpVendedores>(`${GRP_VENDEDOR_URL}/find_all`, value)
}

export function findOneGrpVendedor(id: string) {
  return axios.get<ModelService_GrpVendedor>(`${GRP_VENDEDOR_URL}/find_one/${id}`)
}

export function updateGrpVendedor(
  id: string,
  IdOfV: string,
  IdOrgV: string,
  IdSociedad: string | null,
  Descripcion: string,
  Activo: boolean
) {
  return axios.patch<ModelService_GrpVendedor>(`${GRP_VENDEDOR_URL}/update/${id}`, {
    IdOfV,
    IdOrgV,
    IdSociedad,
    Descripcion,
    Activo,
  })
}

export function removeGrpVendedor(id: string) {
  return axios.post<ModelService_GrpVendedor>(`${GRP_VENDEDOR_URL}/remove/${id}`)
}

//CONDUCTOR
export function createConductor(IdUsuario: number) {
  return axios.post<ModelService_Conductor>(`${CONDUCTOR_URL}/create`, {
    IdUsuario,
  })
}

export function findAllConductores(value: ModelService_Filter) {
  return axios.post<ModelService_Conductores>(`${CONDUCTOR_URL}/find_all`, value)
}

export function findOneConductor(id: number) {
  return axios.get<ModelService_Conductor>(`${CONDUCTOR_URL}/find_one/${id}`)
}

export function updateConductor(IdConductor: number, IdUsuario: number) {
  return axios.patch<ModelService_Conductor>(`${CONDUCTOR_URL}/update/${IdConductor}`, {
    IdUsuario,
  })
}

export function removeConductor(id: number) {
  return axios.post<ModelService_Conductor>(`${CONDUCTOR_URL}/remove/${id}`)
}

// //USUARIOS
// export function createUsuario(
//   Nombres: string,
//   Apellidos: string,
//   Telefono: string,
//   Edad: number,
//   Correo: string
// ) {
//   return axios.post<ModelService_Usuario>(`${USUARIO_URL}/create`, {
//     Nombres,
//     Apellidos,
//     Telefono,
//     Edad,
//     Correo,
//   })
// }

// export function findAllUsuarios() {
//   return axios.get<ModelService_Usuarios>(`${USUARIO_URL}/find_all`)
// }

// export function findOneUsuario(id: string) {
//   return axios.get<ModelService_Usuario>(`${USUARIO_URL}/find_one/${id}`)
// }

// export function updateUsuario(
//   id: number,
//   Nombres: string,
//   Apellidos: string,
//   Telefono: string,
//   Edad: number,
//   Correo: string
// ) {
//   return axios.patch<ModelService_Usuario>(`${USUARIO_URL}/update/${id}`, {
//     Nombres,
//     Apellidos,
//     Telefono,
//     Edad,
//     Correo,
//   })
// }

// export function removeUsuario(id: number) {
//   return axios.post<ModelService_Usuario>(`${USUARIO_URL}/remove/${id}`)
// }

//LOCALIZACION

export function findAllLocalizacion(Nivel: number, IsoPais: string) {
  return axios.post<ModelService_Localizacion>(`${LOCALIZACION_URL}/find_all`, {
    Nivel,
    IsoPais,
  })
}

// export function findAllLocalizacion(Nivel: number, IsoPais: string) {
//   return axios.get<ModelService_Localizacion>(`${LOCALIZACION_URL}/find_all`,{
//     Nivel,
//     IsoPais,
//   })
// }

//TOKEN
export function createToken() {
  return axios.post<ModelService_Token>(`${TOKEN_URL}/create_token`)
}

export function verifyToken() {
  return axios.get<ModelService_VerifyToken>(`${TOKEN_URL}/verify_token`)
}

export function refreshToken(TokenRefresh: string) {
  return axios.post<ModelService_Token>(`${TOKEN_URL}/refresh_token`, {
    TokenRefresh,
  })
}

// FAQ
export function createFAQ(IdSector: string, Descripcion: string) {
  return axios.post<ModelService_FAQ>(`${FAQ_URL}/create`, {
    IdSector,
    Descripcion,
  })
}

export function findAllFAQS(value: ModelService_Filter) {
  return axios.post<ModelService_FAQS>(`${FAQ_URL}/find_all`, value)
}

export function findOneFAQ(id: number) {
  return axios.get<ModelService_FAQ>(`${FAQ_URL}/find_one/${id}`)
}

export function updateFAQ(id: number, IdSector: string, Descripcion: string) {
  return axios.patch<ModelService_FAQ>(`${FAQ_URL}/update/${id}`, {
    IdSector,
    Descripcion,
  })
}

export function removeFAQ(id: number) {
  return axios.post<ModelService_FAQ>(`${FAQ_URL}/remove/${id}`)
}

// FAP
export function createFAP(IdFAQ: number, Descripcion: string) {
  return axios.post<ModelService_FAP>(`${FAP_URL}/create`, {
    IdFAQ,
    Descripcion,
  })
}

export function findAllFAPS(value: ModelService_Filter) {
  return axios.post<ModelService_FAPS>(`${FAP_URL}/find_all`, value)
}

export function findOneFAP(id: number) {
  return axios.get<ModelService_FAP>(`${FAP_URL}/find_one/${id}`)
}

export function updateFAP(id: number, IdFAQ: number, Descripcion: string) {
  return axios.patch<ModelService_FAP>(`${FAP_URL}/update/${id}`, {
    IdFAQ,
    Descripcion,
  })
}

export function removeFAP(id: number) {
  return axios.post<ModelService_FAP>(`${FAP_URL}/remove/${id}`)
}

// CONTACTENOS
export function createContactenos(
  Nombres: string,
  Apellidos: string,
  Mensaje: string,
  Celular: string,
  Email: string,
  IdEstatus: number,
  IdOrgV: string,
  Activo: boolean
) {
  return axios.post<ModelService_Contacteno>(`${CONTACTENOS_URL}/createBO`, {
    Nombres,
    Apellidos,
    Mensaje,
    Celular,
    Email,
    IdEstatus,
    IdOrgV,
    Activo,
  })
}

export function createReclamaciones(
  Nombres: string,
  Apellidos: string,
  Email: string,
  Telefono: string,
  TipoDocumento: string,
  NumDocumento: string,
  Direccion: string,
  Ciudad: string,
  Pais: string,
  TipoReclamo:string,
  FechaIncidencia: string,
  Detalle:string,
  Pedido:string,
  TipoBienContratado:string,
  PadreOMadre:string,
  MontoReclamo:number,
  Descripcion:string,
  FechaRespuesta:string,
  RespuestaAcciones:string,
  IdEstatus: number,
  IdOrgVxLocal: number,
  Activo: boolean
) {
  return axios.post<ModelService_Reclamacion>(`${RECLAMACIONES_URL}/createBO`, {
    Nombres,
    Apellidos,
    Email,
    Telefono,
    TipoDocumento,
    NumDocumento,
    Direccion,
    Ciudad,
    Pais,
    TipoReclamo,
    FechaIncidencia,
    Detalle,
    Pedido,
    TipoBienContratado,
    PadreOMadre,
    MontoReclamo,
    Descripcion,
    FechaRespuesta,
    RespuestaAcciones,
    IdEstatus,
    IdOrgVxLocal,
    Activo,
    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  })
}

export function findAllContactenos(value: ModelService_Filter) {
  return axios.post<ModelService_Contactenos>(`${CONTACTENOS_URL}/find_all`, value)
}

export function findAllReclamaciones(value: ModelService_Filter,idOrgVentas: string) {
  const payload = {
    ...value,
    IdOrgV: idOrgVentas,
  }
  return axios.post<ModelService_Reclamaciones>(`${RECLAMACIONES_URL}/find_all`, payload)
}

export function findAllOrgVByLocal(value: ModelService_Filter2) {
  return axios.post<ModelService_Locales>(`${LOCALES_URL}/find_all_by_orgventas`, value )
}

export function findOneReclamaciones(id: number) {
  return axios.get<ModelService_Reclamacion>(`${RECLAMACIONES_URL}/find_one/${id}`)
}

export function findOneContactenos(id: number) {
  return axios.get<ModelService_Contacteno>(`${CONTACTENOS_URL}/find_one/${id}`)
}

export function updateReclamaciones(
  id: number,
  Nombres: string,
  Apellidos: string,
  // Mensaje: string,
  // Celular: string,
  // Email: string,
  IdEstatus: number,
  NumDocumento: string,
  TipoReclamo: string,
  MontoReclamo:string,
  // IdOrgV: string,
  Activo: boolean
) {
  return axios.patch<ModelService_Reclamacion>(`${RECLAMACIONES_URL}/updateBO/${id}`, {
    Nombres,
    Apellidos,
    // Mensaje,
    // Celular,
    // Email,
    IdEstatus,
    NumDocumento,
    TipoReclamo,
    MontoReclamo,
    // IdOrgV,
    Activo,
  })
}

export function updateContactenos(
  id: number,
  Nombres: string,
  Apellidos: string,
  Mensaje: string,
  Celular: string,
  Email: string,
  IdEstatus: number,
  IdOrgV: string,
  Activo: boolean
) {
  return axios.patch<ModelService_Contacteno>(`${CONTACTENOS_URL}/updateBO/${id}`, {
    Nombres,
    Apellidos,
    Mensaje,
    Celular,
    Email,
    IdEstatus,
    IdOrgV,
    Activo,
  })
}

export function removeContactenos(id: number) {
  return axios.post<ModelService_Contacteno>(`${CONTACTENOS_URL}/remove/${id}`)
}

export function removeReclamaciones(id: number) {
  return axios.post<ModelService_Reclamacion>(`${RECLAMACIONES_URL}/remove/${id}`)
}

// SURVEY
export function createSurvey(
  IdSector: string,
  Pregunta: string,
  Respuesta: string,
  Activo: boolean
) {
  return axios.post<ModelService_Survey>(`${SURVEY_URL}/create`, {
    IdSector,
    Pregunta,
    Respuesta,
    Activo,
  })
}

export function findAllSurvey(value: ModelService_Filter) {
  return axios.post<ModelService_Surveys>(`${SURVEY_URL}/find_all`, value)
}

export function findOneSurvey(id: string) {
  return axios.get<ModelService_Survey>(`${SURVEY_URL}/find_one/${id}`)
}

export function updateSurvey(
  id: string,
  IdSector: string,
  Pregunta: string,
  Respuesta: string,
  Activo: boolean
) {
  return axios.patch<ModelService_Survey>(`${SURVEY_URL}/update/${id}`, {
    IdSector,
    Pregunta,
    Respuesta,
    Activo,
  })
}

export function removeSurvey(id: string) {
  return axios.post<ModelService_Survey>(`${SURVEY_URL}/remove/${id}`)
}

// CLIENTES PERSONA
export function createClientePersona(
  IdUsuario: number | null,
  IdOrgV: string,
  Nombres: string,
  ApellidoPaterno: string,
  ApellidoMaterno: string,
  FechaNacimiento: string,
  Genero: string | null,
  Email: string | null,
  Celular: string,
  DNI: string | null,
  CodPais: string | null,
  // Rol: string,
  // ContactoPrincipal: boolean,
  // PasoOnboarding: boolean,
  Activo: boolean
) {
  return axios.post<ModelService_ClientePersona>(`${CLIENTES_PERSONA_URL}/create`, {
    IdUsuario,
    IdOrgV,
    Nombres,
    ApellidoPaterno,
    ApellidoMaterno,
    FechaNacimiento,
    Genero,
    Email,
    Celular,
    DNI,
    CodPais,
    // Rol,
    // ContactoPrincipal,
    // PasoOnboarding,
    Activo,
  })
}

export function findAllClientePersonas(value: ModelService_Filter) {
  return axios.post<ModelService_ClientePersonas>(`${CLIENTES_PERSONA_URL}/find_all`, value)
}

export function findOneClientePersona(id: number) {
  return axios.get<ModelService_ClientePersona>(`${CLIENTES_PERSONA_URL}/find_one/${id}`)
}

export function updateClientePersona(
  id: number,
  IdUsuario: number | null,
  IdOrgV: string,
  Nombres: string,
  ApellidoPaterno: string,
  ApellidoMaterno: string,
  FechaNacimiento: string,
  Genero: string | null,
  Email: string | null,
  Celular: string,
  DNI: string | null,
  CodPais: string | null,
  // Rol: string,
  // ContactoPrincipal: boolean,
  // PasoOnboarding: boolean,
  Activo: boolean
) {
  return axios.patch<ModelService_ClientePersona>(`${CLIENTES_PERSONA_URL}/update/${id}`, {
    IdUsuario,
    IdOrgV,
    Nombres,
    ApellidoPaterno,
    ApellidoMaterno,
    FechaNacimiento,
    Genero,
    Email,
    Celular,
    DNI,
    CodPais,
    // Rol,
    // ContactoPrincipal,
    // PasoOnboarding,
    Activo,
  })
}

export function removeClientePersona(id: number) {
  return axios.post<ModelService_ClientePersona>(`${CLIENTES_PERSONA_URL}/remove/${id}`)
}

// CLIENTES EMPRESARIAL
export function createClienteEmpresarial(
  IdUsuario: number | null, 
  IdOrgV: string,
  RazonSocial: string,
  RUC: string,
  Email: string | null,
  Celular: string,
  CodPais: string | null,
  Activo: boolean
) {
  return axios.post<ModelService_ClienteEmpresarial>(`${CLIENTES_EMPRESARIAL_URL}/create`, {
    IdUsuario,
    IdOrgV,
    RazonSocial,
    RUC,
    Email,
    Celular,
    CodPais,
    Activo,
  })
}

export function findAllClienteEmpresarial(value: ModelService_Filter) {
  return axios.post<ModelService_ClienteEmpresariales>(
    `${CLIENTES_EMPRESARIAL_URL}/find_all`,
    value
  )
}

export function findOneClienteEmpresarial(id: number) {
  return axios.get<ModelService_ClienteEmpresarial>(`${CLIENTES_EMPRESARIAL_URL}/find_one/${id}`)
}

export function updateClienteEmpresarial(
  id: number,
  IdUsuario: number | null,
  IdOrgV: string,
  RazonSocial: string,
  RUC: string,
  Email: string | null,
  Celular: string,
  CodPais: string | null,
  Activo: boolean
) {
  return axios.patch<ModelService_ClienteEmpresarial>(`${CLIENTES_EMPRESARIAL_URL}/update/${id}`, {
    IdUsuario,
    IdOrgV,
    RazonSocial,
    RUC,
    Email,
    Celular,
    CodPais,
    Activo,
  })
}

export function removeClienteEmpresarial(id: number) {
  return axios.post<ModelService_ClienteEmpresarial>(`${CLIENTES_EMPRESARIAL_URL}/remove/${id}`)
}

//PERSONA CONTACTO
export function createPersonaContacto(
  IdClienteEmpresarial: number | null,
  IdClientePersona: number | null,
  NombreContacto: string,
  ApellidoPaterno: string,
  ApellidoMaterno: string,
  Email: string,
  Activo: boolean
) {
  return axios.post<ModelService_PersonaContacto>(`${PERSONA_CONTACTO_URL}/create`, {
    IdClienteEmpresarial,
    IdClientePersona,
    NombreContacto,
    ApellidoPaterno,
    ApellidoMaterno,
    Email,
    Activo,
  })
}

export function findAllPersonaContacto(value: ModelService_Filter) {
  return axios.post<ModelService_PersonaContactos>(`${PERSONA_CONTACTO_URL}/find_all`, value)
}

export function findOnePersonaContacto(id: number) {
  return axios.get<ModelService_PersonaContacto>(`${PERSONA_CONTACTO_URL}/find_one/${id}`)
}

export function updatePersonaContacto(
  id: number,
  IdClienteEmpresarial: number | null,
  IdClientePersona: number | null,
  NombreContacto: string,
  ApellidoPaterno: string,
  ApellidoMaterno: string,
  Email: string,
  Activo: boolean
) {
  return axios.patch<ModelService_PersonaContacto>(`${PERSONA_CONTACTO_URL}/update/${id}`, {
    IdClienteEmpresarial,
    IdClientePersona,
    NombreContacto,
    ApellidoPaterno,
    ApellidoMaterno,
    Email,
    Activo,
  })
}

export function removePersonaContacto(id: number) {
  return axios.post<ModelService_PersonaContacto>(`${PERSONA_CONTACTO_URL}/remove/${id}`)
}

// CONTACTO CONSENTIMIENTO
export function createContactoConsentimiento(
  IdContacto: number,
  IdConsentxOrgV: number,
  Activo: boolean
) {
  return axios.post<ModelService_ConsentPersona>(`${CONTACTO_CONSENTIMIENTO_URL}/create`, {
    IdContacto,
    IdConsentxOrgV,
    Activo,
  })
}

export function findAllContactoConsentimiento(value: ModelService_Filter) {
  return axios.post<ModelService_ConsentPersonas>(`${CONTACTO_CONSENTIMIENTO_URL}/find_all`, value)
}

export function findOneContactoConsentimiento(id: number) {
  return axios.get<ModelService_ConsentPersona>(`${CONTACTO_CONSENTIMIENTO_URL}/find_one/${id}`)
}

export function updateContactoConsentimiento(
  id: number,
  IdContacto: number,
  IdConsentxOrgV: number,
  Activo: boolean
) {
  return axios.patch<ModelService_ConsentPersona>(`${CONTACTO_CONSENTIMIENTO_URL}/update/${id}`, {
    IdContacto,
    IdConsentxOrgV,
    Activo,
  })
}

export function removeContactoConsentimiento(id: number) {
  return axios.post<ModelService_ConsentPersona>(`${CONTACTO_CONSENTIMIENTO_URL}/remove/${id}`)
}

//GRP CONSENTIMIENTO
export function createGrpConsentimiento(Detalle: string, Activo: boolean) {
  return axios.post<ModelService_GrpConsentimiento>(`${GRP_CONSENTIMIENTO_URL}/create`, {
    Detalle,
    Activo,
  })
}

export function findAllGrpConsentimiento(value: ModelService_Filter) {
  return axios.post<ModelService_GrpConsentimientos>(`${GRP_CONSENTIMIENTO_URL}/find_all`, value)
}

export function findOneGrpConsentimiento(id: number) {
  return axios.get<ModelService_GrpConsentimiento>(`${GRP_CONSENTIMIENTO_URL}/find_one/${id}`)
}

export function updateGrpConsentimiento(id: number, Detalle: string, Activo: boolean) {
  return axios.patch<ModelService_GrpConsentimiento>(`${GRP_CONSENTIMIENTO_URL}/update/${id}`, {
    Detalle,
    Activo,
  })
}

export function removeGrpConsentimiento(id: number) {
  return axios.post<ModelService_GrpConsentimiento>(`${GRP_CONSENTIMIENTO_URL}/remove/${id}`)
}

//CONSENTIMIENTO
export function createConsentimiento(
  IdGrupoConsentimiento: number,
  DescripcionCorta: string,
  DescripcionLarga: string,
  Activo: boolean
) {
  return axios.post<ModelService_Consentimiento>(`${CONSENTIMIENTO_URL}/create`, {
    IdGrupoConsentimiento,
    DescripcionCorta,
    DescripcionLarga,
    Activo,
  })
}

export function findAllConsentimiento(value: ModelService_Filter) {
  return axios.post<ModelService_Consentimientos>(`${CONSENTIMIENTO_URL}/find_all`, value)
}

export function findOneConsentimiento(id: number) {
  return axios.get<ModelService_Consentimiento>(`${CONSENTIMIENTO_URL}/find_one/${id}`)
}

export function updateConsentimiento(
  id: number,
  IdGrupoConsentimiento: number,
  DescripcionCorta: string,
  DescripcionLarga: string,
  Activo: boolean
) {
  return axios.patch<ModelService_Consentimiento>(`${CONSENTIMIENTO_URL}/update/${id}`, {
    IdGrupoConsentimiento,
    DescripcionCorta,
    DescripcionLarga,
    Activo,
  })
}

export function removeConsentimiento(id: number) {
  return axios.post<ModelService_Consentimiento>(`${CONSENTIMIENTO_URL}/remove/${id}`)
}

//ORG SAAS
export function findAllOrgSaas(value: ModelService_Filter, token: string) {
  const payload = {
    ...value,
    token: token,
  }

  return axios.post<ModelServiceOrgSaas>(`${ORGSAAS_ONBOARDING_URL}/find_all`, payload)
}

//USUARIO
const dominioActual = window.location.hostname
export function createUsuario(
  IdPais: string | null,
  Email: string,
  Contrasena: string | null,
  Celular: string,
  Nombres: string,
  ApellidoPaterno: string,
  ApellidoMaterno: string,
  RazonSocial: string | null,
  FechaNacimiento: string | null,
  Genero: string | null,
  IdTipoUsuario: number | null,
  // IdAplicativoxOV: number,
  IdRolesxAplicatxOV: number,
  token: string
) {
  return axios.post<ModelServiceUsuario>(`${USUARIO_ONBOARDING_URL}/createBO`, {
    IdPais,
    Email,
    Contrasena,
    Celular,
    Nombres,
    ApellidoPaterno,
    ApellidoMaterno,
    RazonSocial,
    FechaNacimiento,
    Genero,
    IdTipoUsuario,
    Activo: true,
    // DominioWeb: dominioActual === 'localhost' ? 'i001fo.maxattention.com' : dominioActual,
    Token: token,
    // IdAplicativoxOV,
    IdRolesxAplicatxOV,
  })
}

export function findAllUsuarios(value: ModelService_Filter, token: string) {
  const payload = {
    ...value,
    token: token,
  }

  return axios.post<ModelServiceUsuarios>(`${USUARIO_ONBOARDING_URL}/find_all`, payload)
}

export function findAllUsuariosbyOrgVentas(
  value: ModelService_Filter,
  token: string,
  orgventas: string,
  idRol: string,
  Kit?: string
) {
  const payload = {
    ...value,
    Token: token,
    IdOrgV: orgventas,
    IdRol: idRol,
    Kit: Kit,
  }

  return axios.post<ModelServiceUsuarios>(
    `${USUARIO_ONBOARDING_URL}/find_all_by_orgventas`,
    payload
  )
}

export function findOneUsuario(id: number, token: string) {
  return axios.post<ModelServiceUsuario>(`${USUARIO_ONBOARDING_URL}/find_one/${id}`, {
    Token: token,
  })
}

export function updateUsuario(
  id: number,
  IdPais: string | null,
  // IdRol: string | null,
  Email: string,

  Celular: string,
  Nombres: string,
  ApellidoPaterno: string,
  ApellidoMaterno: string,

  RazonSocial: string | null,
  FechaNacimiento: string | null,
  // IdOrgSaas: number,
  Genero: string | null,

  IdTipoUsuario: number | null,
  // IdAplicativo: number,
  Activo: boolean,
  token: string
  // IdAplicativoxOV: number
) {
  return axios.patch<ModelServiceUsuario>(`${USUARIO_ONBOARDING_URL}/updateBO/${id}`, {
    IdPais,
    // IdRol,
    Email,
    Celular,
    Nombres,
    ApellidoPaterno,
    ApellidoMaterno,
    RazonSocial,
    FechaNacimiento,
    // IdOrgSaas,
    Genero,

    IdTipoUsuario,
    // IdAplicativo,
    Activo,
    Token: token,
    // IdAplicativoxOV,
  })
}

export function removeUsuario(id: number, token: string) {
  return axios.post<ModelServiceUsuario>(`${USUARIO_ONBOARDING_URL}/remove/${id}`, {
    Token: token,
  })
}

//PAISES
export function findAllPaises(value: ModelService_Filter, token: string) {
  const payload = {
    ...value,
    token: token,
  }

  return axios.post<ModelServicePaises>(`${PAIS_ONBOARDING_URL}/find_all`, payload)
}

//ROL
export function findAllRol(value: ModelService_Filter, token: string) {
  const payload = {
    ...value,
    token: token,
  }

  return axios.post<ModelServiceRoles>(`${ROL_ONBOARDING_URL}/find_all2`, payload)
}

//TIPO USUARIO

export function findAllTipoUsuario(value: ModelService_Filter, token: string) {
  const payload = {
    ...value,
    token: token,
  }

  return axios.post<ModelServiceTipoUsuarios>(`${TIPO_USUARIO_ONBOARDING_URL}/find_all`, payload)
}

// EMPLEADOS
export function createEmpleado(IdUsuario: number, IdOrgV: string, Activo: boolean) {
  return axios.post<ModelService_Empleado>(`${EMPLEADO_URL}/create`, {
    IdUsuario,
    IdOrgV,
    Activo,
  })
}

export function findAllEmpleados(value: ModelService_Filter) {
  return axios.post<ModelService_Empleados>(`${EMPLEADO_URL}/find_all`, value)
}

export function findOneEmpleado(id: number) {
  return axios.get<ModelService_Empleado>(`${EMPLEADO_URL}/find_one/${id}`)
}

export function updateEmpleado(id: number, IdUsuario: number, IdOrgV: string, Activo: boolean) {
  return axios.patch<ModelService_Empleado>(`${EMPLEADO_URL}/update/${id}`, {
    IdUsuario,
    IdOrgV,
    Activo,
  })
}

export function removeEmpleado(id: number) {
  return axios.post<ModelService_Empleado>(`${EMPLEADO_URL}/remove/${id}`)
}

// CONSTANTES
export function createConstante(
  IdGrupo: string,
  IdConstante: string,
  Valor: string,
  Descripcion: string,
  IdOrgSaas: number,
  Activo: boolean
) {
  return axios.post<ModelService_Constante>(`${CONSTANTES_URL}/create`, {
    IdGrupo,
    IdConstante,
    Valor,
    Descripcion,
    IdOrgSaas,
    Activo,
  })
}

export function findAllConstantes(value: ModelService_Filter) {
  return axios.post<ModelService_Constantes>(`${CONSTANTES_URL}/find_all`, value)
}

export function findOneConstante(id: string, idOrgSaas: number) {
  return axios.get<ModelService_Constante>(`${CONSTANTES_URL}/find_one/${id}/${idOrgSaas}`)
}

export function updateConstante(
  IdGrupo: string,
  IdConstante: string,
  Valor: string,
  Descripcion: string,
  IdOrgSaas: number,
  Activo: boolean
) {
  return axios.patch<ModelService_Constante>(
    `${CONSTANTES_URL}/update/${IdConstante}/${IdOrgSaas}`,
    {
      IdGrupo,
      IdConstante,
      Valor,
      Descripcion,
      IdOrgSaas,
      Activo,
    }
  )
}

export function removeConstante(id: string, idOrgSaas: number) {
  return axios.post<ModelService_Constante>(`${CONSTANTES_URL}/remove/${id}/${idOrgSaas}`)
}

// ESPECIFICACIONES TECNICAS
export function createEspecifTecnicas(
  Descripcion: string,
  CriterioOrden1: number,
  Activo: boolean
) {
  return axios.post<ModelService_EspecifTecnica>(`${ESPECIFICACIONES_TECNICAS_URL}/create`, {
    Descripcion,
    CriterioOrden1,
    Activo,
  })
}

export function findAllEspecifTecnicas(value: ModelService_Filter) {
  return axios.post<ModelService_EspecifTecnicas>(
    `${ESPECIFICACIONES_TECNICAS_URL}/find_all`,
    value
  )
}

export function findOneEspecifTecnicas(id: number) {
  return axios.get<ModelService_EspecifTecnica>(`${ESPECIFICACIONES_TECNICAS_URL}/find_one/${id}`)
}

export function updateEspecifTecnicas(
  id: number,
  Descripcion: string,
  CriterioOrden1: number,
  Activo: boolean
) {
  return axios.patch<ModelService_EspecifTecnica>(`${ESPECIFICACIONES_TECNICAS_URL}/update/${id}`, {
    Descripcion,
    CriterioOrden1,
    Activo,
  })
}

export function removeEspecifTecnicas(id: number) {
  return axios.post<ModelService_EspecifTecnica>(`${ESPECIFICACIONES_TECNICAS_URL}/remove/${id}`)
}

//DOCUMENTOS

export function createDocumento(
  IdUsuario: number,
  Descripcion: string,
  NumeroDocumento: string,
  IdTipoDocumento: number,

  FileTipoMime: string,
  FileBase64: string,
  FileNombre: string,

  FechaEmision: string | null,
  FechaCaducidad: string | null,
  Activo: boolean,
  token: string
) {
  return axios.post<ModelServiceDocumento>(`${DOCUMENTO_URL}/create`, {
    IdUsuario,
    Descripcion,
    NumeroDocumento,
    IdTipoDocumento,

    FileTipoMime,
    FileBase64,
    FileNombre,

    FechaEmision,
    FechaCaducidad,
    Activo,
    Token: token,
  })
}

export function findAllTipoDocumento(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceTipoDocumentos>(`${TIPO_DOCUMENTO_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function findOneDocumento(id: number, token: string) {
  return axios.post<ModelServiceDocumento>(`${DOCUMENTO_URL}/find_one/${id}`, {
    Token: token,
  })
}

export function updateDocumento(
  id: number,
  IdUsuario: number,
  Descripcion: string,
  NumeroDocumento: string,
  IdTipoDocumento: number,

  FileTipoMime: string | null,
  FileBase64: string | null,
  FileNombre: string | null,

  FechaEmision: string | null,
  FechaCaducidad: string | null,
  Activo: boolean,
  token: string
) {
  return axios.patch<ModelServiceDocumento>(`${DOCUMENTO_URL}/update/${id}`, {
    IdUsuario,
    Descripcion,
    NumeroDocumento,
    IdTipoDocumento,

    FileTipoMime,
    FileBase64,
    FileNombre,

    FechaEmision,
    FechaCaducidad,
    Activo,
    Token: token,
  })
}

export function findAllDocumentos(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceDocumentos>(`${DOCUMENTO_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function removeDocumento(id: number, token: string) {
  return axios.post<ModelServiceDocumento>(`${DOCUMENTO_URL}/remove/${id}`, {
    Token: token,
  })
}

//VERIFICACION

export function createVerificacion(
  IdAdjunto: number,
  FechaSolicitud: string,
  FechaFinVerificacion: string,
  Activo: boolean,
  token: string
) {
  return axios.post<ModelServiceVerificacion>(`${VERIFICACION_URL}/create`, {
    IdAdjunto,
    FechaSolicitud,
    FechaFinVerificacion,
    Activo,
    Token: token,
  })
}

export function findOneVerificacion(id: number, token: string) {
  return axios.post<ModelServiceVerificacion>(`${VERIFICACION_URL}/find_one/${id}`, {
    Token: token,
  })
}

export function updateVerificacion(
  id: number,
  IdAdjunto: number,
  FechaSolicitud: string,
  FechaFinVerificacion: string,
  Activo: boolean,
  token: string
) {
  return axios.patch<ModelServiceVerificacion>(`${VERIFICACION_URL}/update/${id}`, {
    IdAdjunto,
    FechaSolicitud,
    FechaFinVerificacion,
    Activo,
    Token: token,
  })
}

export function findAllVerificacion(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceVerificaciones>(`${VERIFICACION_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function removeVerificacion(id: number, token: string) {
  return axios.post<ModelServiceVerificacion>(`${VERIFICACION_URL}/remove/${id}`, {
    Token: token,
  })
}

//DOMICILIO

export function createDomicilio(
  IdUsuario: number,
  Direccion1: string,
  Direccion2: string,
  CodigoPostal: string,

  Departamento: number | null,
  Provincia: number | null,
  Distrito: number | null,
  CentroPoblado: string | null,

  Estado: number | null,
  Delegacion: number | null,
  Municipio: string | null,
  Colonia: string | null,
  Ciudad: string | null,

  NroExt: string,
  NroInt: string,
  Activo: boolean,
  token: string
) {
  return axios.post<ModelServiceDomicilio>(`${DOMICILIO_URL}/create`, {
    IdUsuario,
    Direccion1,
    Direccion2,
    CodigoPostal,

    Departamento,
    Provincia,
    Distrito,
    CentroPoblado,

    Estado,
    Delegacion,
    Municipio,
    Colonia,
    Ciudad,

    NroExt,
    NroInt,
    Activo,
    Token: token,
  })
}

//LOCALIZACIONES

export function findAllLocalizaciones(Id: number, Pais: string, token: string) {
  return axios.post<ModelService_Localizacion>(`${DOMICILIO_URL}/find_localizaciones`, {
    Id,
    Pais,
    Token: token,
  })
}

export function findOneDomicilio(id: number, token: string) {
  return axios.post<ModelServiceDomicilio>(`${DOMICILIO_URL}/find_one/${id}`, {
    Token: token,
  })
}

export function updateDomicilio(
  id: number,
  IdUsuario: number,
  Direccion1: string,
  Direccion2: string,
  CodigoPostal: string,

  Departamento: number | null,
  Provincia: number | null,
  Distrito: number | null,
  CentroPoblado: string | null,

  Estado: number | null,
  Delegacion: number | null,
  Municipio: string | null,
  Colonia: string | null,
  Ciudad: string | null,

  NroExt: string,
  NroInt: string,
  Activo: boolean,
  token: string
) {
  return axios.patch<ModelServiceDomicilio>(`${DOMICILIO_URL}/update/${id}`, {
    IdUsuario,
    Direccion1,
    Direccion2,
    CodigoPostal,

    Departamento,
    Provincia,
    Distrito,
    CentroPoblado,

    Estado,
    Delegacion,
    Municipio,
    Colonia,
    Ciudad,

    NroExt,
    NroInt,
    Activo,
    Token: token,
  })
}

export function findAllDomicilio(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceDomicilios>(`${DOMICILIO_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function removeDomicilio(id: number, token: string) {
  return axios.post<ModelServiceDomicilio>(`${DOMICILIO_URL}/remove/${id}`, {
    Token: token,
  })
}

//INTERACCION
export function createInteraccion(
  IdUsuario: number,
  IdActividad: string,
  FechaInteraccion: string,
  IdMetodo2FA: number,
  IdDispositivo: number,
  IPDispositivo: string,
  SistemaOperativo: string,
  IMEI: string,
  Activo: boolean,
  token: string
) {
  return axios.post<ModelServiceInteraccion>(`${INTERACCION_URL}/create`, {
    IdUsuario,
    IdActividad,
    FechaInteraccion,
    IdMetodo2FA,
    IdDispositivo,
    IPDispositivo,
    SistemaOperativo,
    IMEI,
    Activo,
    Token: token,
  })
}

export function findAllActividad(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceActividades>(`${ACTIVIDAD_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function findAllDispositivos(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceDispositivos>(`${DISPOSITIVO_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function findAllMetodoFA(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceMetodosFA>(`${METODOFA_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function findOneInteraccion(id: number, token: string) {
  return axios.post<ModelServiceInteraccion>(`${INTERACCION_URL}/find_one/${id}`, {
    Token: token,
  })
}

export function updateInteraccion(
  id: number,
  IdUsuario: number,
  IdActividad: string,
  FechaInteraccion: string,
  IdMetodo2FA: number,
  IdDispositivo: number,
  IPDispositivo: string,
  SistemaOperativo: string,
  IMEI: string,
  Activo: boolean,
  token: string
) {
  return axios.patch<ModelServiceInteraccion>(`${INTERACCION_URL}/update/${id}`, {
    IdUsuario,
    IdActividad,
    FechaInteraccion,
    IdMetodo2FA,
    IdDispositivo,
    IPDispositivo,
    SistemaOperativo,
    IMEI,
    Activo,
    Token: token,
  })
}

export function findAllInteraccion(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceInteracciones>(`${INTERACCION_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function removeInteraccion(id: number, token: string) {
  return axios.post<ModelServiceInteraccion>(`${INTERACCION_URL}/remove/${id}`, {
    Token: token,
  })
}

//ROLES

export function createRoles_x_aplicativo_x_ov(
  RolesXAplicatXOv: ModelRoles_x_Aplicativo_x_OrgVenta[],
  token: string
) {
  return axios.post<ModelServiceRoles_x_Aplicativo_x_OrgVenta>(
    `${ROLES_X_APLICATIVO_X_OV_URL}/create2`,
    { RolesXAplicatXOv, Token: token }
  )
}

export function findAllRoles_x_aplicativo_x_ov(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceRoles_x_Aplicativo_x_OrgVentas>(
    `${ROLES_X_APLICATIVO_X_OV_URL}/find_all`,
    { ...value, token: token }
  )
}

export function findAllRoles_x_aplicativo_x_ovByOrgVentas(
  value: ModelService_Filter,
  orgventas: string,
  token: string
) {
  const payload = {
    ...value,
    Token: token,
    IdOrgV: orgventas,
  }

  return axios.post<ModelServiceRoles_x_Aplicativo_x_OrgVentas>(
    `${ROLES_X_APLICATIVO_X_OV_URL}/find_all_by_orgventas`,
    payload
  )
}

export function findOneRoles_x_aplicativo_x_ov(id: number, token: string) {
  return axios.post<ModelServiceRoles_x_Aplicativo_x_OrgVenta>(
    `${ROLES_X_APLICATIVO_X_OV_URL}/find_one/${id}`,
    { Token: token }
  )
}

export function updateRoles_x_aplicativo_x_ov(
  id: number,
  IdAplicativoxOV: number,
  IdRol: string,
  Activo: boolean,
  token: string
) {
  return axios.patch<ModelServiceRoles_x_Aplicativo_x_OrgVenta>(
    `${ROLES_X_APLICATIVO_X_OV_URL}/update/${id}`,
    {
      IdAplicativoxOV,
      IdRol,
      Activo,
      Token: token,
    }
  )
}

export function removeRoles_x_aplicativo_x_ov(id: number, token: string) {
  return axios.post<ModelServiceRoles_x_Aplicativo_x_OrgVenta>(
    `${ROLES_X_APLICATIVO_X_OV_URL}/remove/${id}`,
    {
      Token: token,
    }
  )
}

export function findOneRol_Usuario(id: number, token: string) {
  return axios.post<ModelServiceRol_Usuario>(`${ROL_X_USUARIO_URL}/find_one/${id}`, {
    Token: token,
  })
}

export function updateRol_Usuario(
  id: number,
  IdUsuario: number,
  IdRolesxAplicatxOV: number,
  Activo: boolean,
  token: string
) {
  return axios.patch<ModelServiceRol_Usuario>(`${ROL_X_USUARIO_URL}/update/${id}`, {
    IdUsuario,
    IdRolesxAplicatxOV,
    Activo,
    Token: token,
  })
}

export function findAllRol_Usuario(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceRol_Usuarios>(`${ROL_X_USUARIO_URL}/find_all`, {
    ...value,
    token: token,
  })
}

export function findAllRol_UsuarioByAppOV(
  value: ModelService_Filter,
  IdAplicativoxOV: number,
  token: string
) {
  return axios.post<ModelServiceRol_Usuarios>(`${ROL_X_USUARIO_URL}/find_all_by_appxov`, {
    ...value,
    IdAplicativoxOV: IdAplicativoxOV,
    Token: token,
  })
}

export function removeRol_Usuario(id: number, token: string) {
  return axios.post<ModelServiceRol_Usuario>(`${ROL_X_USUARIO_URL}/remove/${id}`, {
    Token: token,
  })
}

export function findAllAplicativo_x_ov(value: ModelService_Filter, token: string) {
  return axios.post<ModelServiceAplicativo_x_OrgVentas>(`${APLICATIVO_X_OV_URL}/find_all`, {
    ...value,
    token: token,
  })
}

//ROL X USUARIO
export function createRol_Usuario(
  IdUsuario: number,
  IdRolesxAplicatxOV: number,
  Activo: boolean,
  token: string
) {
  return axios.post<ModelServiceRol_Usuario>(`${ROL_X_USUARIO_URL}/create`, {
    IdUsuario,
    IdRolesxAplicatxOV,
    Activo,
    Token: token,
  })
}

//OrgVentas por locales////////////////////////
export function createOrgVentasxLocales(IdOrgV: string, IdLocal: number, Activo: boolean) {
  return axios.post<ModelService_OrgVentasxLocal>(`${ORG_VENTAS_X_LOCALES_URL}/create`, {
    IdOrgV,
    IdLocal,
    Activo,
  })
}

export function findAllOrgVentasxLocales(value: ModelService_Filter) {
  return axios.post<ModelService_OrgVentasxLocales>(`${ORG_VENTAS_X_LOCALES_URL}/find_all`, value)
}

export function findOneOrgVentasxLocales(id: number) {
  return axios.get<ModelService_OrgVentasxLocal>(`${ORG_VENTAS_X_LOCALES_URL}/find_one/${id}`)
}

export function updateOrgVentasxLocales(
  id: number,
  IdOrgV: string,
  IdLocal: number,
  Activo: boolean
) {
  return axios.patch<ModelService_OrgVentasxLocal>(`${ORG_VENTAS_X_LOCALES_URL}/update/${id}`, {
    IdOrgV,
    IdLocal,
    Activo,
  })
}

export function removeOrgVentasxLocales(id: number) {
  return axios.post<ModelService_OrgVentasxLocal>(`${ORG_VENTAS_X_LOCALES_URL}/remove/${id}`)
}

export function updateAplicativoOvUsuario(
  IdAplicativoxOV: number,
  IdUsuario: number,
  Contrasena: string,
  Activo: boolean,
  token: string
) {
  return axios.post<ModelServiceAplicativoOvUsuario>(
    `${APLICATIVO_OV_USUARIO_URL}/recover_password`,
    {
      IdAplicativoxOV,
      IdUsuario,
      Contrasena,
      Activo,
      Token: token,
    }
  )
}

//CATEGORIA

export function createCategoria(Descripcion: string, IdOrgV: string, AfectacionPrecio: boolean) {
  return axios.post<ModelService_Categoria>(`${CATEGORIA_URL}/create`, {
    Descripcion,
    IdOrgV,
    AfectacionPrecio,
  })
}

export function findAllCategorias(value: ModelService_Filter) {
  return axios.post<ModelService_Categorias>(`${CATEGORIA_URL}/find_all`, value)
}

export function findOneCategoria(id: number) {
  return axios.get<ModelService_Categoria>(`${CATEGORIA_URL}/find_one/${id}`)
}

export function updateCategoria(
  idCategoria: number,
  Descripcion: string,
  IdOrgV: string,
  AfectacionPrecio: boolean
) {
  return axios.patch<ModelService_Categoria>(`${CATEGORIA_URL}/update/${idCategoria}`, {
    Descripcion,
    IdOrgV,
    AfectacionPrecio,
  })
}

export function removeCategoria(id: number) {
  return axios.post<ModelService_Categoria>(`${CATEGORIA_URL}/remove/${id}`)
}

//UNIDAD MEDIDA

export function createUnidadMedida(
  IdUM: string,
  DescripcionLarga: string,
  DescripcionCorta: string
) {
  return axios.post<ModelService_UnidadMedida>(`${UNIDADMEDIDA_URL}/create`, {
    IdUM,
    DescripcionLarga,
    DescripcionCorta,
  })
}

export function findAllUnidadMedida(value: ModelService_Filter) {
  return axios.post<ModelService_UnidadMedidas>(`${UNIDADMEDIDA_URL}/find_all`, value)
}

export function findOneUnidadMedida(id: string) {
  return axios.get<ModelService_UnidadMedida>(`${UNIDADMEDIDA_URL}/find_one/${id}`)
}

export function updateUnidadMedida(
  IdUM: string,
  DescripcionLarga: string,
  DescripcionCorta: string
) {
  return axios.patch<ModelService_UnidadMedida>(`${UNIDADMEDIDA_URL}/update/${IdUM}`, {
    IdUM,
    DescripcionLarga,
    DescripcionCorta,
  })
}

export function removeUnidadMedida(id: string) {
  return axios.post<ModelService_UnidadMedida>(`${UNIDADMEDIDA_URL}/remove/${id}`)
}

//RECURSO ORG VENTAS

export function createRecursoOrgVentas(
  IdOrgV: string,
  IdResource: number,
  IdCanalDistribucion: string | null,
  Activo: boolean
) {
  return axios.post<ModelService_RecursoOrgVenta>(`${RECURSO_ORGVENTAS_URL}/create`, {
    IdOrgV,
    IdResource,
    IdCanalDistribucion,
    Activo,
  })
}

export function findAllRecursoOrgVentas(value: ModelService_Filter) {
  return axios.post<ModelService_RecursoOrgVentas>(`${RECURSO_ORGVENTAS_URL}/find_all`, value)
}

export function findOneRecursoOrgVentas(id: number) {
  return axios.get<ModelService_RecursoOrgVenta>(`${RECURSO_ORGVENTAS_URL}/find_one/${id}`)
}

export function updateRecursoOrgVentas(
  id: number,
  IdOrgV: string,
  IdResource: number,
  IdCanalDistribucion: string,
  Activo: boolean
) {
  return axios.patch<ModelService_RecursoOrgVenta>(`${RECURSO_ORGVENTAS_URL}/update/${id}`, {
    IdOrgV,
    IdResource,
    IdCanalDistribucion,
    Activo,
  })
}

export function removeRecursoOrgVentas(id: number) {
  return axios.post<ModelService_RecursoOrgVenta>(`${RECURSO_ORGVENTAS_URL}/remove/${id}`)
}
